import { axiosClient, getCSRFToken } from 'www/utils'
import type {
  ApiAppointmentRestrictionsRequestGet,
  ApiAppointmentRestrictionsResponseGet,
} from 'www/vue_components/common/AppointmentRestrictions/api/apiAppointmentRestrictions.types'

export default {
  async get(params: ApiAppointmentRestrictionsRequestGet) {
    return axiosClient.get<ApiAppointmentRestrictionsResponseGet>(
      `/api/lpu/${params.lpu_id}/doctor/${params.doctor_id}/restriction-appointment/`,
      {
        headers: {
          'X-CSRFToken': getCSRFToken(),
        },
      },
    )
      .then(({ data }) => data)
  },
}
